import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { BookV1, NewBookV1 } from '@ilteducation/content-registry-types';
import { startCase } from 'lodash';
import BookMarketsAvailability from '@/components/book/BookMarketsAvailability.vue';
import { getBookUpdates, patchBookFields } from '@/foundations/helpers/bookUpdateDiff';
import store from '@/store';
import { useDuplicateBooks } from '@/comp/use-duplicate-books';
import DuplicateBooksTable from '@/components/book/DuplicateBooksTable.vue';
import ContentToCollection from '@/components/collections/ContentToCollection.vue';
import BookFilesUpload from '../../components/book/BookFilesUpload.vue';
import BooksForm from './Form.vue';

type Props = {
  id: string;
  title: string;
  item: BookV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: BookV1;
}



const bulkUpdateDialog = ref(false);
const bookMetaChanges = ref<Partial<NewBookV1>>({});
const changedFieldNamesSelectedForBulkUpdate = ref<(keyof BookV1)[]>([]);
const selectedDuplicateBooks = ref<BookV1[]>([]);
const isBulkUpdateLoading = ref(false);
const { books: duplicateBooks } = useDuplicateBooks(props.item);

const handleSelectedDuplicateBooks = (selectedBooks: BookV1[]) => {
  selectedDuplicateBooks.value = selectedBooks;
};

const handleBookMetaSaved = (updatedBookMeta: NewBookV1) => {
  bulkUpdateDialog.value = false;
  changedFieldNamesSelectedForBulkUpdate.value = [];

  if (!duplicateBooks.value.length) {
    return;
  }

  const previousBook = props.item;

  const updatedBook: BookV1 = {
    ...previousBook,
    ...updatedBookMeta,
  };

  const updates = getBookUpdates(previousBook, updatedBook);
  bookMetaChanges.value = updates;

  if (Object.keys(updates).length > 0) {
    bulkUpdateDialog.value = true;
  }
};

const changedFieldsNames = computed(() => Object.keys(bookMetaChanges.value).map((key) => key));

const hideDialog = () => {
  bulkUpdateDialog.value = false;
};

const applyUpdatesToDuplicateBooks = async () => {
  isBulkUpdateLoading.value = true;

  try {
    const bulkUpdateBookMeta: Partial<BookV1> = {};
    changedFieldNamesSelectedForBulkUpdate.value.forEach((selectedField) => {
      bulkUpdateBookMeta[selectedField] = bookMetaChanges.value[selectedField];
    });

    console.log('bulkUpdateBookMeta', bulkUpdateBookMeta);

    await Promise.all(
      selectedDuplicateBooks.value.map((selectedDuplicateBook) => {
        const patchedDuplicateMeta = patchBookFields(selectedDuplicateBook, bulkUpdateBookMeta);

        return store.dispatch(`books/update`, {
          id: selectedDuplicateBook.id,
          data: patchedDuplicateMeta,
        });
      }),
    );

    hideDialog();
  } finally {
    isBulkUpdateLoading.value = false;
  }
};

return { __sfc: true,props, bulkUpdateDialog, bookMetaChanges, changedFieldNamesSelectedForBulkUpdate, selectedDuplicateBooks, isBulkUpdateLoading, duplicateBooks, handleSelectedDuplicateBooks, handleBookMetaSaved, changedFieldsNames, hideDialog, applyUpdatesToDuplicateBooks, startCase, BookMarketsAvailability, DuplicateBooksTable, ContentToCollection, BookFilesUpload, BooksForm }
}

})